import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
import { lighten } from "polished";
import theme from "../../../styles/theme.semantic";
import { withExtendedClass } from "../../../utils/utilities.style";

const lightenHover = 0.5;
const DropdownList = styled.div.attrs(({ className }) =>
  withExtendedClass({
    className,
    extend: "dropdown-content"
  })
)`
  a {
    color: ${props => props.color};
    margin-right: 0 !important;
    text-decoration: none;
    font-weight: ${props => props.fontWeight};
    display: block;
    padding: ${props => props.padding};
    &:hover {
      background-color: ${props =>
        lighten(lightenHover, props.hoverBackgroundColor)};
    }
    &:first-child {
      margin-top: 0;
    }
    :focus {
      outline-offset: -2px;
    }
  }
`;

DropdownList.defaultProps = {
  color: theme.components.dropList.color,
  fontWeight: String(theme.weight.base),
  padding: `${theme.sizes.xs2} ${theme.sizes.xl}`,
  hoverBackgroundColor: theme.components.dropList.hoverBackgroundColor
};

DropdownList.propTypes = {
  padding: PropTypes.string,
  color: PropTypes.string,
  fontWeight: PropTypes.string,
  hoverBackgroundColor: PropTypes.string,
  className: PropTypes.string
};

export default DropdownList;
